import { localDb } from '@/data/local/database'
import { ensureLocalIdentity } from '@/services/identity/local-identity'
import { listLocalNotebooks, saveLocalNotebook, deleteLocalNotebook } from '@/data/local/notebooks'
import type { Note } from '@/domain/types'
import type { NotebookInput } from '../../../shared/notebooks'

const json = (body: unknown, status = 200) => new Response(JSON.stringify(body), { status, headers: { 'Content-Type': 'application/json' } })
export async function handleLocalNotebookApi(request: Request, url: URL, id?: string) {
  try {
    if (request.method === 'GET') {
      if (!id) {
        const books = await listLocalNotebooks()
        return json({ notebooks: books.filter(n => !url.searchParams.get('module') || n.notebookBook?.module === url.searchParams.get('module')) })
      }
      const identity = await ensureLocalIdentity()
      const book = await localDb.notes.get(id)
      if (!book || book.workspaceId !== identity.workspaceId || book.deletedAtMs || !book.notebookBook) return json({ error: '错题本不存在或已删除' }, 404)
      if (url.searchParams.get('compact') === 'true') {
        const questions: Partial<Note>[] = []
        // Read one body at a time; never materialize a whole illustrated book.
        for (const questionId of book.notebookBook.questionIds) {
          const n = await localDb.notes.get(questionId)
          if (n && !n.deletedAtMs && n.workspaceId === identity.workspaceId) questions.push({
            id: n.id, title: n.title, category: n.category, tags: n.tags, type: n.type,
            recordKind: n.recordKind, content: '', createdAtMs: n.createdAtMs, updatedAtMs: n.updatedAtMs,
          })
        }
        return json({ questions })
      }
      const questions = (await localDb.notes.bulkGet(book.notebookBook!.questionIds))
        .filter(n => n && !n.deletedAtMs && n.workspaceId === identity.workspaceId)
      return json({ notebook: book, questions })
    }
    const body = await request.json() as Partial<NotebookInput> & { expectedVersion?: number; confirm?: boolean }
    if (request.method === 'POST' && !id || request.method === 'PATCH' && id) return json({ notebook: await saveLocalNotebook(body, id, body.expectedVersion) }, id ? 200 : 201)
    if (request.method === 'DELETE' && id) {
      if (body.confirm !== true || !Number.isInteger(body.expectedVersion)) return json({ error: '删除需要确认并提供当前版本' }, 400)
      await deleteLocalNotebook(id, body.expectedVersion!)
      return json({ ok: true })
    }
    return json({ error: '不支持的操作' }, 405)
  } catch (error) { return json({ error: error instanceof Error ? error.message : '错题本操作失败' }, 400) }
}
